var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container text-center"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-10",domProps:{"innerHTML":_vm._s(_vm.item.content)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }